import { getAllVersions } from 'apis/projectProposals.api';
import { useMemo } from 'react';
import { useQuery } from 'react-query';

const useGetAllVersions = (projectProposalId, conds) => {
  const { data: allProjectVersionsData, ...rest } = useQuery(
    ['allProjectVersions', projectProposalId, conds],
    () =>
      getAllVersions(projectProposalId, {
        ...conds,
      })
  );

  const data = useMemo(() => allProjectVersionsData?.data ?? [], [allProjectVersionsData]);

  return {
    data,
    ...rest,
  };
};

const useGetLatestVersion = (projectProposalId, conds) => {
  const { data: allProjectVersionsData } = useGetAllVersions(projectProposalId, conds);

  const latestVersion = useMemo(() => {
    if (allProjectVersionsData?.length > 0) {
      return (
        allProjectVersionsData?.reduce((latest, current) =>
          current.version > latest.version ? current : latest
        ) ?? null
      );
    }
    return null;
  }, [allProjectVersionsData]);

  return latestVersion;
};

export { useGetAllVersions, useGetLatestVersion };
